import shuffle from 'hs-lodash/shuffle';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { chirpEnumToString } from 'academy-common-lib/utils/chirp';
// TODO: Remove shuffle once backend implements randomisation
export const shuffleTaskAnswers = task => {
  var _task$quizResponse;
  if (!(task !== null && task !== void 0 && (_task$quizResponse = task.quizResponse) !== null && _task$quizResponse !== void 0 && _task$quizResponse.quiz)) {
    return task;
  }
  return Object.assign({}, task, {
    quizResponse: Object.assign({}, task.quizResponse, {
      quiz: Object.assign({}, task.quizResponse.quiz, {
        questions: task.quizResponse.quiz.questions.map(question => Object.assign({}, question, {
          answers: shuffle(question.answers)
        }))
      })
    })
  });
};
/**
 * Extracts and normalizes video metadata from content objects.
 * Standardizes field names and formats for use across different content types.
 *
 * @param content - Content object with video metadata. If undefined, returns all undefined fields.
 * @returns Normalized metadata with consistent field names and types
 */
export const extractVideoMetadata = content => {
  if (!content) {
    return {
      contentPortalId: undefined,
      outputLanguage: undefined,
      videoId: undefined
    };
  }
  const outputLanguage = content.language ? readUnhandledEnumCase(content.language).toUpperCase() : undefined;
  return {
    contentPortalId: content.hubId || content.portalId,
    outputLanguage,
    videoId: content.reference ? Number(content.reference) : undefined
  };
};

/**
 * Tracking properties sent to analytics for AI feature interactions
 */

/**
 * Builds standardized tracking properties from content objects.
 * Works with both legacy types (string arrays) and CHIRP types (enum arrays with unhandledEnumCase).
 *
 * @param content - Content object (can be undefined)
 * @param contentType - 'VIDEO' for lessons, 'SHORT_FORM_CONTENT' for shorts
 * @param contentId - Content ID
 * @param professorId - Array of professor IDs
 * @param industry - User's industry label (from user settings)
 */
export const buildInteractiveContentTrackingProps = ({
  content,
  contentType,
  contentId,
  professorId,
  industry,
  visibility
}) => {
  var _content$businessObje, _content$hsSoftwareFi, _content$subCategorie, _content$useCases;
  const visibilityString = chirpEnumToString(visibility);
  if (!content) {
    return {
      contentType,
      id: contentId,
      industry,
      professorId,
      visibility: visibilityString
    };
  }
  const businessObjectives = (_content$businessObje = content.businessObjectives) === null || _content$businessObje === void 0 ? void 0 : _content$businessObje.map(readUnhandledEnumCase);
  const hsSoftwareFilters = Array.isArray(content.hubSpotSoftwareTools) ? content.hubSpotSoftwareTools.map(readUnhandledEnumCase) : (_content$hsSoftwareFi = content.hsSoftwareFilters) === null || _content$hsSoftwareFi === void 0 ? void 0 : _content$hsSoftwareFi.map(readUnhandledEnumCase);
  const subCategory = (_content$subCategorie = content.subCategories) === null || _content$subCategorie === void 0 ? void 0 : _content$subCategorie.map(readUnhandledEnumCase);
  const useCases = (_content$useCases = content.useCases) === null || _content$useCases === void 0 ? void 0 : _content$useCases.map(readUnhandledEnumCase);
  const contentLanguage = content.language ? readUnhandledEnumCase(content.language) : undefined;
  return {
    businessObjectives,
    contentLanguage,
    contentType,
    creatorHubId: content.hubId,
    hsSoftwareFilters,
    id: contentId,
    industry,
    name: content.name,
    professorId,
    subCategory,
    useCases,
    visibility: visibilityString
  };
};